import { Component, Input } from '@angular/core';

import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { DropdownOptionModel } from '../../../../Forms/models/dropdown-option.model';
import { LinkTypesEnum, linkTypesToLabelStrings } from '../../../enums/link-types.enum';
import { SocialLinkModel } from '../../../models/link.model';
import { LinksListFieldModel } from '../../../models/links-list-field.model';
import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';

type LinkModelWithError = SocialLinkModel & {
    error?: boolean;
};

@Component({
    selector: 'agpr-links-list-field',
    templateUrl: './links-list-field.component.html',
    styleUrls: ['./links-list-field.component.scss'],
    standalone: false
})
export class LinksListFieldComponent extends AbstractFormFieldComponent {
    readonly linkTypes = LinkTypesEnum;
    readonly buttonTypes = ButtonTypesEnum;
    readonly linkLimit = 10;
    readonly linkTypesToLabelStrings = linkTypesToLabelStrings;
    readonly linkTypesOptions = [
        new DropdownOptionModel(linkTypesToLabelStrings[LinkTypesEnum.twitter], LinkTypesEnum.twitter),
        new DropdownOptionModel(linkTypesToLabelStrings[LinkTypesEnum.facebook], LinkTypesEnum.facebook),
        new DropdownOptionModel(linkTypesToLabelStrings[LinkTypesEnum.instagram], LinkTypesEnum.instagram),
        new DropdownOptionModel(linkTypesToLabelStrings[LinkTypesEnum.youtube], LinkTypesEnum.youtube),
        new DropdownOptionModel(linkTypesToLabelStrings[LinkTypesEnum.linkedin], LinkTypesEnum.linkedin),
        new DropdownOptionModel(linkTypesToLabelStrings[LinkTypesEnum.snapchat], LinkTypesEnum.snapchat),
        new DropdownOptionModel(linkTypesToLabelStrings[LinkTypesEnum.tiktok], LinkTypesEnum.tiktok),
        new DropdownOptionModel(linkTypesToLabelStrings[LinkTypesEnum.bluesky], LinkTypesEnum.bluesky),
        new DropdownOptionModel(linkTypesToLabelStrings[LinkTypesEnum.website], LinkTypesEnum.website)
    ];

    @Input() declare field: LinksListFieldModel;
    @Input() declare value: LinkModelWithError[];

    constructor() {
        super();
    }

    addLink() {
        this.value.push(new SocialLinkModel(LinkTypesEnum.twitter, ''));
        this.valueChange();
    }

    valueChange(link?: LinkModelWithError) {
        if (link) {
            this.validateLink(link);
        }

        this.changes.emit(this.value);
    }

    onLinkAction(action: 'moveUp' | 'moveDown' | 'delete', index: number) {
        switch (action) {
            case 'moveUp':
                this.value.splice(index - 1, 0, this.value.splice(index, 1)[0]);
                break;
            case 'moveDown':
                this.value.splice(index + 1, 0, this.value.splice(index, 1)[0]);
                break;
            case 'delete':
                this.value.splice(index, 1);
                break;
        }
        this.valueChange();
    }

    private validateLink(link: LinkModelWithError) {
        const isValid = link.isUrlValid();
        link.error = !isValid;
    }
}
